import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme } from '../../contexts/ThemeContext';
import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';

import styles from '../../../styles/partials/results-cta.module.scss';

import Scene from '../../../img/iga/2024/points-scene.png';

// import * as AppPropTypes from '../../lib/PropTypes';

const propTypes = {
    callToAction: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function ResultsCta({ callToAction, className }) {
    const { name: theme, isVariant } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { title = null, description = null, url = null, button = null } = callToAction || {};
    const inner = (
        <div className={styles.inner}>
            {title !== null ? <h2 className={styles.title}>{title}</h2> : null}
            {theme === 'iga' && isVariant('habs') ? (
                <img className={styles.icon} src={Scene} alt="Scene" />
            ) : null}
            {description !== null ? (
                <p
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            ) : null}
            {url !== null ? (
                <div className={styles.cta}>
                    {button || <FormattedMessage defaultMessage="See" description="button label" />}
                </div>
            ) : null}
        </div>
    );
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {url !== null ? (
                <Button href={url} external className={styles.button}>
                    {inner}
                </Button>
            ) : (
                <div className={styles.button}>{inner}</div>
            )}
        </div>
    );
}

ResultsCta.propTypes = propTypes;
ResultsCta.defaultProps = defaultProps;

export default ResultsCta;
